import Instance from "../../../../Axios";

// New Actions for the app

const GetWorkPermitAccountables = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/accountables`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_WORK_PERMIT_ACCOUNTABLES", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetWorkPermitAccountables;
